/**
 * Overlay dark/light palette mode onto a resolved legacy Theme.
 * Adjusts text tokens to reflect cookie/user preference.
 *
 * Note: We only touch fields that exist on `Theme.colors` to satisfy typing.
 * Background styling should rely on existing tokens (e.g., aux.*) downstream.
 *
 * @param theme - Resolved legacy theme object
 * @param mode - 'light' | 'dark'
 * @returns Theme with updated text tokens for the given mode
 */
import { Theme } from 'shared/theme/theme';

export function applyPaletteModeToLegacyTheme(
  theme: Theme,
  mode: 'light' | 'dark'
): Theme {
  const isDark = mode === 'dark';
  const colors = theme.colors || ({} as Theme['colors']);

  // Conservative overlay: update only text colors
  const textPrimary = isDark ? '#FFFFFF' : colors?.text?.primary ?? '#000000';
  const textSecondary = isDark
    ? '#B0BEC5'
    : colors?.text?.secondary ?? '#666666';

  return {
    ...theme,
    colors: {
      ...colors,
      text: {
        primary: textPrimary,
        secondary: textSecondary,
      },
    },
  };
}
